import { CLASS_NAME_PREFIX } from "../__config__/constants";

export const SearchInputClassName = `${CLASS_NAME_PREFIX}-search-input`;
